import type { SiteControllerSettingBaseFormModel } from "../../../../base/type";
import type { SiteControllerSettingTemairazuFormModel } from "../../../type";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
};

export const baseViewModelToViewModelConverter = ({ viewModel: _viewModel }: Props) => {
	const { hotelID, password, setUpRoomPriceByChillnn } = _viewModel;

	hotelID;
	password;
	setUpRoomPriceByChillnn;

	const viewModel: SiteControllerSettingTemairazuFormModel["ViewModel"] = {
		isDirty: false,
		hasError: false,

		hotelID,
		password,
		setUpRoomPriceByChillnn,
	};

	return { viewModel };
};
